var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(function () { return _vm.close(false); }),expression:"() => close(false)"}],staticClass:"sv-menu"},[_c('div',{staticClass:"sv-menu__container",on:{"click":_vm.toggleShow}},[_c('SvIcon',{staticClass:"sv-menu__icon",attrs:{"icon":"menu","width":25,"height":16}})],1),_c('transition',{attrs:{"name":"menu"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"sv-menu__dropdown"},[_c('SvButton',{staticClass:"sv-menu__button",attrs:{"view":"secondary","text":"Удалить","prependIcon":{
                  icon: 'remove',
                  width: 24,
                  height: 24,
                  hover: '#1993EB',
                  default: '#B7BAC6'
              }},on:{"click":_vm.remove}}),_c('SvButton',{staticClass:"sv-menu__button",attrs:{"view":"secondary","text":"Копировать","prependIcon":{
                  icon: 'copy',
                  width: 24,
                  height: 24,
                  hover: '#1993EB',
                  default: '#B7BAC6'
              }},on:{"click":_vm.copy}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }